import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmptyListComponent } from './empty-list.component';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [EmptyListComponent],
  imports: [CommonModule, MatIconModule, TranslateModule],
  exports: [EmptyListComponent],
})
export class EmptyListModule {}
